<template>
  <div class="sumarySpace">
    <!-- 联盟介绍 -->
    <div class="sumaryItem">
      <div class="summary-title">
        <h1>联盟介绍</h1>
      </div>
      <div class="summary-text-cup">
        <p v-html="firstP" class="summary-text"></p>
      </div>
      <div class="summary-more">
        <el-button type="primary" @click="checkMore(1)">查看更多<i class="el-icon-right  el-icon--right"></i></el-button>
      </div>
      <div class="just-bg">
        <img :src="commonbg" alt="">
      </div>
    </div>
    <!-- 联盟章程 -->
    <div class="chapterItem">
      <div class="chapter-title">
        <h1 @click="checkMore(2)">联盟章程</h1>
      </div>
      <el-row :gutter="40">
        <el-col :span="8" v-for="(chapter,index) in chapterList" :key="index">
          <div class="chapter-pot">
            <div class="chapter-img">
              <img :src="chapterIcon[index].path" alt="">
            </div>
            <div class="chapter-text">
              <div class="chapter-text-title">
                <h4 class="highLight">{{chapter.title}}</h4>
              </div>
              <div v-html=chapter.text class="chapter-text-type"></div>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- <div class="chapter-more">
        <el-button type="primary" @click="checkMore(2)">查看更多<i class="el-icon-right  el-icon--right"></i></el-button>
      </div> -->
    </div>
  </div>
</template>
<script>
import { homeCommonData } from '@/api/frontApi/frontHome';
export default {
  data() {
    return {
      firstP: '',
      chapterIcon: [
        {
          path: '../../../../static/img/summary/doc.png',
          index: 1
        },
        {
          path: '../../../../static/img/summary/org.png',
          index: 2
        },
        {
          path: '../../../../static/img/summary/member.png',
          index: 3
        },
        {
          path: '../../../../static/img/summary/guanli.png',
          index: 4
        },
        {
          path: '../../../../static/img/summary/know.png',
          index: 5
        },
        {
          path: '../../../../static/img/summary/ctl.png',
          index: 6
        }
      ],
      chapterList: [
        {
          path: '../../../../static/img/summary/doc.png',
          index: 1,
          chapterTitle: '',
          chapterTip: ''
        },
        {
          path: '../../../../static/img/summary/org.png',
          index: 2,
          chapterTitle: '',
          chapterTip: ''
        },
        {
          path: '../../../../static/img/summary/member.png',
          index: 3,
          chapterTitle: '',
          chapterTip: ''
        },
        {
          path: '../../../../static/img/summary/guanli.png',
          index: 4,
          chapterTitle: '',
          chapterTip: ''
        },
        {
          path: '../../../../static/img/summary/know.png',
          index: 5,
          chapterTitle: '',
          chapterTip: ''
        },
        {
          path: '../../../../static/img/summary/ctl.png',
          index: 6,
          chapterTitle: '',
          chapterTip: ''
        }
      ]
    };
  },
  computed: {
    commonbg() {
      return this.$store.state.commonbg;
    }
  },
  created() {
    this.getSummary();
    this.getChapter();
  },
  methods: {
    getContent(content) {
      let reg = /<\/?.+?\/?>/g;
      return content.replace(reg, '');
    },
    getChapter() {
      // 联盟章程
      homeCommonData({ pageNo: 1, pageSize: 100, commonType: 2 }).then(res => {
        let tempArr = res.data.records;
        this.chapterList = [];
        for (let i = 0; i < tempArr.length; i++) {
          let tempChapter = {
            title: '',
            text: ''
          };
          tempChapter.title = tempArr[i].commonName;
          tempChapter.text = this.getContent(tempArr[i].commonText);
          // this.chapterList[i].chapterTip = tempArr[i].commonText;
          // this.chapterList[i].chapterTitle = tempArr[i].commonName;
          this.chapterList.push(tempChapter);
        }
      });
    },
    getSummary() {
      // 联盟简介
      homeCommonData({ pageNo: 1, pageSize: 1, commonType: 7 }).then(res => {
        this.firstP = res.data.records[0].commonText;
      });
    },
    checkMore(moreType) {
      switch (moreType) {
        case 1:
          this.$router.push({ name: 'overview', params: { summaryType: 1 } });
          break;
        default:
          this.$router.push({ name: 'overview', params: { summaryType: 2 } });
          break;
      }
    }
  }
};
</script>
<style scoped>
.sumarySpace {
  width: 100%;
  margin: 0 auto;
  padding-top: 1%;
}
.sumaryItem {
  width: 100%;
}
.summary-title {
  width: 100%;
  text-align: center;
}

.summary-text {
  width: 60%;
  height: 60px;
  margin: 0 auto;
}
.summary-more {
  width: 100%;
  text-align: center;
  margin: 20px auto;
}
.chapterItem {
  width: 80%;
  margin: 0 auto;
}
.chapter-title {
  text-align: center;
  width: 100%;
}
.chapter-title h1:hover {
  cursor: pointer;
  color: #55afdf;
}
.chapter-pot {
  overflow: hidden;
  width: 98%;
}
.chapter-img {
  float: left;
  width: 20%;
  margin-top: 9%;
}
.chapter-text {
  float: left;
  width: 80%;
  overflow: hidden;
  max-height: 150px;
  text-overflow: -o-ellipsis-lastline;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.chapter-text-title {
  width: 100%;
  text-align: center;
}
/* .chapter-text-title:hover {
  cursor: pointer;
} */
.chapter-text-type {
  font-size: 14px;
  text-indent: 2em;
  font-family: Arial, 'Microsoft YaHei';
}
.chapter-more {
  margin-top: 2%;
  width: 100%;
  text-align: center;
}
.just-bg {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/home/homeSummary.vue